<template>
  <div class="login" :style="loginStyle">
    <img :src="bgImg" width="100%" height="100%"/>

    <!-- <div style="width:100%;height:50px;" :style="background"></div> -->

    <div style="display:flex">
      <!-- <div style="width: 54%;height: 100%;display: inline;"></div> -->

      <div style="width: 35%;height: 100%;display: inline;position: fixed;top: 100px;right: 100px;">

        <div style="width:100%;height:50px;margin-bottom: 40px;">
          <span style="line-height: 50px;font-size:38px;color: white;">极光智模</span>
        </div>

        <div id="login_container">1</div>
      </div>

      <div style="width: 10%;height: 100%;display: inline;background-color: pink;"></div>

    </div>

    <!-- <div style="width:100%;height:180px;"></div> -->

    <p style="position: fixed;bottom: 0px;right: 627px;">
      <a href="https://beian.miit.gov.cn" style="text-decoration: none;">
        <span style="color: white;">粤ICP备2022114400号-2</span>
      </a>
    </p>
  </div>
</template>

<script>
// @ is an alias to /src
import Loginpage from '@/assets/images/login.png';

export default {
  name: "Login",
  components: {},
  data() {
    return {
      bgImg:require('../assets/images/login.png'),
      loginStyle:{
        width: '100%',
        height:document.documentElement.clientHeight
      }
    };
  },
  methods: {
    // loginCallback(result) {
    //   console.log('result')
    //   console.log(result)
    // }
  },
  mounted() {
    // console.log('mounted')
    // console.log(document.documentElement.clientHeight)

    this.loginStyle.height=(document.documentElement.clientHeight-5)+'px'

    var obj = new WxLogin({
      self_redirect: false,
      id: "login_container",
      appid: "wxa3170bd635d38f87",
      scope: "snsapi_login",
      redirect_uri: "https://www.mojumes.cn/shiro/wx/login",
      // front_url:"",
      state: "",
      style: "",
      href: ""
    });

    // console.log('obj')
    // console.log(obj)
    // let self = this
    // window["loginCallback"] = (result) => {
    //   self.loginCallback(result)
    // }

    window.onresize=()=>{
      return (()=>{
        // setTimeout(function(){
        this.$nextTick(()=>{
          
            // console.log('this.$refs.wrapper')
            this.loginStyle.height=(document.documentElement.clientHeight-5)+'px'
          
        })
      // },500)
      })()
    }

  },
  created(){
    // console.log('created')
  },
  updated() {
    // console.log('updated')
    // let self = this
    // window["loginCallback"] = (result) => {
    //   self.loginCallback(result)
    // }
  }
};
</script>

<style>
body {
  /* overflow: hidden; */
  padding: 0;
  margin: 0;
}

.login {
  width: 100%;
  /* height: 100%; */
  z-index: -1;
  /* margin: 0px; */
  /* background-color: orange; */
  /* background-image: require('../assets/images/login.png'); */
}

#login_container {
  /* position: fixed;
  top: 100px;
  right: 100px; */
  background-color: white;
  border-radius: 5px;
  
}
</style>